<template>
	<BaseModal :title="$t('WEBAPP_REPORT_HEADLINE_THANKYOU')" :closable="true" @dismiss="$emit('dismiss')">
		<div class="success-modal-content">
			<div v-html="$t('WEBAPP_REPORT_THANKYOU_TEXT')" />
			<br />
			<div v-if="email" v-html="$t('WEBAPP_REPORT_THANKYOU_TEXT_MAIL', { email: email })" />
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';

const props = withDefaults(
	defineProps<{
		email?: string | null;
		closeDelay?: number;
	}>(),
	{
		email: null,
		closeDelay: 3000,
	}
);

onMounted(() => {
	setTimeout(() => {
		VFMHelper.close();
	}, props.closeDelay);
});
</script>

<style lang="scss">
.success-modal-content {
	padding: 0px 15px;
}
</style>
